<!--
 * @ProjectName: Union Service
 * @FileName:
 * @PackageName:
 * @Author:
 * @Date: 2020-07-06 16:13:01
 * @LastEditTime: 2020-08-24 10:29:36
 * @LastEditors: Zhanglei
 * @Description:
 * @FilePath: /desktop/src/App.vue
 * @copyright(c) 2017-2020 BMW Brilliance Automotive Co., Ltd.
-->
<template>
  <div id="app">
    <keep-alive :include="caches">
      <router-view v-if="isRouterAlive"></router-view>
    </keep-alive>
  </div>
</template>

<script>
import { getToken } from '@/utils/auth'
import { loadingStart, loadingFinish } from '@/utils/loading'
import axios from 'axios';
export default {
  name: 'App',
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      direction: '',
      isRouterAlive: true,
      /**
       * include定义需要缓存的组件
       * caches为include的值
       */
      caches: []
    }
  },
  created () {
    this.$store.getters.getCurrentLanguage;
    this.$router.beforeEach((to, from, next) => {
      loadingStart();
      /**
       *  使用keepAlive例子
       * 1.首先在路由中的meta标签中记录keepAlive的属性为true
       * 2.在创建router实例的时候加上scrollBehavior方法
       * 3.在需要缓存的router-view组件上包裹keep-alive组件
       * 4.不需要缓存的页面，可以在缓存的组件里的路由钩子函数中做判断
       */
      // if (from.path.startsWith('/infoDetailMain') && to.path == '/infoSearchList') {
      //   from.meta.keepAlive = false
      // }
      const meta = to.meta || {}
      if (getToken()) {
        next()
      } else {
        if (meta.isAuth === false) {
           alert(111)
          next()
        } else {
           alert(222)
          next('/Login')
        }
      }
    })

    this.$router.afterEach(() => {
      loadingFinish()
    })
    /**
     * 配置在插入、更新或者移除 DOM 时，应用的过渡效果
     */
    window.aa = this
    let push = this.$router.push
    this.$router.push = (...args) => {
      this.direction = 'slide-left'
      push.apply(this.$router, args)
    }
    let replace = this.$router.replace
    this.$router.replace = (...args) => {
      this.direction = 'slide-left'
      replace.apply(this.$router, args)
    }
    // this.role = getStore({name: 'role'})
    // console.log('role:', this.role)
  },
  methods: {
    after () {
      this.direction = 'slide-right'
    },
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue